import React, { useEffect, useRef, useState } from "react";
import "./ImpactNumbers.css";

import House from "../Image/House-removebg-preview.png";
import User from "../Image/user-removebg-preview.png";
import Map from "../Image/map-removebg-preview.png";
import Cup from "../Image/cup-removebg-preview.png";

const statsData = [
  { icon: House, value: 100, suffix: "%", text: "Compliances Fulfilled" },
  { icon: User, value: 100, suffix: "%", text: "Client Satisfaction" },
  // { icon: Map, value: 100, suffix: "%", text: "Increasing Every Month" },
  { icon: Map, value: 100, suffix: "%", text: "Professional Team" },

  { icon: Cup, value: 100, suffix: "+", text: "Million Sq. Feet Served" },
];

const ImpactNumbers = ({ variant = "glass" }) => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && setVisible(true),
      { threshold: 0.4 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`impact-pro-wrapper ${variant}`}
    >
      <div className="impact-pro-inner">
        <div className="impact-pro-header">
          <h2>Our Impact in Numbers</h2>
          <p>Delivering excellence across India</p>
        </div>

        <div className="impact-pro-grid">
          {statsData.map((item, i) => (
            <CounterCard key={i} {...item} start={visible} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImpactNumbers;

/* ---------------- Counter Card ---------------- */

const CounterCard = ({ icon, value, suffix, text, start }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!start) return;
    let current = 0;
    const step = Math.ceil(value / 40);

    const timer = setInterval(() => {
      current += step;
      if (current >= value) {
        current = value;
        clearInterval(timer);
      }
      setCount(current);
    }, 30);

    return () => clearInterval(timer);
  }, [start, value]);

  return (
    <div className="impact-pro-card">
      <div className="impact-pro-icon">
        <img src={icon} alt="" />
      </div>
      <h3 className="impact-pro-value">
        {count}
        {suffix}
      </h3>
      <p className="impact-pro-text">{text}</p>
    </div>
  );
};
